import type { PropsWithChildren } from 'react'

export type DefinitionListColumnProps = UiComponentProps & PropsWithChildren

/**
 * Composition marker for `DefinitionList` multi-column layout.
 * Children are read from JSX by `DefinitionList` and are not rendered by this component.
 */
export function DefinitionListColumn(_props: DefinitionListColumnProps) {
  return null
}

DefinitionListColumn.displayName = 'DefinitionList.Column'
